
import React from 'react'
import RightSidebarGlobal from '../../Components/RightSidebarGlobal'
import minister_2 from "../../Assets/images/minister_2.png";

function ManagementDeskPage() {
  return (
    <>

    <div class="wrapper">
        <div class="inner_page_Sec">
        <div class="col-sm-8 float-left left_sec searchPageTop">
    
        <h1>MD's Desk</h1>

        <h2>Shared Vision of Honorable Managing Director, BENFED:-</h2>
    
        <p>
          <img src={minister_2} alt="" style={{float:"left", marginRight:15, marginBottom:15}}/>
          Driven by the sole noble motive of FARMER WELFARE based on the strengthen base of flourishing agriculture co-operatives 
          reaching every artery of West Bengal – BENFED Family is working relentlessly with a smiling face. We want to see the 
          reflection of the same smile on the faces of our beloved farmers that may be through supplying Agri-Inputs at the right 
          time and correct Price, may be through Procuring their produces at Minimum Support Price (MSP) or providing Engineering 
          EPC services at co-operative society level. It’s our collective effort to synonymize BENFED with "কৃষকের বন্ধু” i.e. 
          ‘farmer’s friend’ – our true identity.</p>
    
    
        
    
        </div>
        <div class="col-sm-4 float-left">
        <RightSidebarGlobal/>
        </div>
    
        </div>
        </div>
    
        </>
  )
}

export default ManagementDeskPage